<template>
  <div class="iphone-container">
    <!-- iPhone Frame -->
    <div class="iphone-frame">
      <!-- Dynamic Notch -->
      <div class="iphone-notch">
        <div class="camera"></div>
        <div class="sensor"></div>
        <div class="speaker"></div>
      </div>

      <!-- Screen Content -->
      <div class="screen">
        <!-- Dynamic Background Image -->
        <div class="background-image"
             v-if="previewImage"
             :style="{ backgroundImage: 'url(' + previewImage + ')' }">
        </div>
        <!-- Points Overview Card -->
        <div class="points-card">
          <h4>{{ title }}</h4>
          <h1 class="points"><strong>1.070</strong> <small>Punkte</small></h1>
          <!-- Only show expiring points if checkbox is checked -->
          <p class="expiring-points" v-if="showExpiringPoints">
            <span>{{ expiringPointsButton }} 376</span>
          </p>
          <button class="info-btn" style="pointer-events: none;">Mehr Infos</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoyaltyPointOverviewMobilePreview",
  props: {
    initialPreviewImage: String,
    initialTitle: String,
    initialShowExpiringPoints: {
      type: [Boolean, String],
      default: false
    },
    initialExpiringPointsButton: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      previewImage: this.initialPreviewImage || null,
      title: this.initialTitle || "",
      showExpiringPoints: this.parseBoolean(this.initialShowExpiringPoints),
      expiringPointsButton: this.initialExpiringPointsButton || "Davon verfallen bald: "
    };
  },
  watch: {
    initialShowExpiringPoints: {
      immediate: true,
      handler(newValue) {
        this.showExpiringPoints = this.parseBoolean(newValue);
      }
    },
    showExpiringPoints(newValue) {
      if (newValue) {
        if (!this.expiringPointsButton) {
          this.expiringPointsButton = "Davon verfallen bald: ";
        }
      } else {
        this.expiringPointsButton = ""; // Clear when unchecked
      }
    }
  },
  methods: {
    parseBoolean(value) {
      return value === true || value === "true" || value === "1" || value === 1;
    }
  },
  mounted() {
    window.addEventListener("image-selected", (event) => {
      this.previewImage = event.detail;
    });

    window.addEventListener("title-updated", (event) => {
      this.title = event.detail;
    });

    window.addEventListener("show-expiring-points-updated", (event) => {
      this.showExpiringPoints = this.parseBoolean(event.detail);
    });

    window.addEventListener("expiring-points-button-updated", (event) => {
      this.expiringPointsButton = event.detail;
    });
  }
};
</script>

<style scoped>
/* Center everything */
.iphone-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* iPhone Frame */
.iphone-frame {
  width: 390px; /* iPhone width */
  height: 844px; /* iPhone height */
  background: #fff;
  border-radius: 40px;
  border: 8px solid #222;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* Notch (Dynamic Island look) */
.iphone-notch {
  width: 140px;
  height: 35px;
  background: #222;
  border-radius: 20px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px;
}

/* Notch elements */
.camera {
  width: 12px;
  height: 12px;
  background: black;
  border-radius: 50%;
}
.sensor {
  width: 8px;
  height: 8px;
  background: grey;
  border-radius: 50%;
}
.speaker {
  width: 40px;
  height: 5px;
  background: darkgray;
  border-radius: 3px;
}

/* Screen */
.screen {
  flex-grow: 1;
  background: white;
  padding: 0px;
  margin-top: 50px; /* Space for notch */
  position: relative;
}

/* Background Image */
.background-image {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}

/* Points Overview Card */
.points-card {
  width: 80%;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  position: absolute;
  top: 90px; /* Position below background */
  left: 50%;
  transform: translateX(-50%);
}

.points-card h4 {
  font-size: 16px;
  color: black;
  margin-bottom: 5px;
}

.points {
  font-size: 32px;
  font-weight: bold;
  color: black;
}

.expiring-points {
  font-size: 14px;
  color: #FE4300;
  text-decoration: underline;
}

.info-btn {
  width: 100%;
  padding: 10px;
  background: black;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
}

.refresh-btn {
  margin-top: 15px;
  background: white;
  color: black;
  padding: 10px 20px;
  border: 2px solid black;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;
}

.refresh-btn:hover {
  background: black;
  color: white;
}
</style>
